/*** IMPORTS FROM imports-loader ***/
(function() {
var define = false;

'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _createClass = require('babel-runtime/helpers/create-class')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var Ad = (function (_Component) {
	_inherits(Ad, _Component);

	function Ad() {
		_classCallCheck(this, Ad);

		_Component.apply(this, arguments);
	}

	Ad.prototype.render = function render() {
		var _classNames;

		var styles = require('./Ad.css');
		var _props = this.props;
		var children = _props.children;
		var className = _props.className;
		var href = _props.href;
		var onClick = _props.onClick;
		var ratio = _props.ratio;

		var adClassNames = _classnames2['default']((_classNames = {}, _classNames[styles['Base--' + ratio]] = true, _classNames[className] = className, _classNames));

		if (onClick) {
			return _react2['default'].createElement(
				'div',
				{ className: adClassNames },
				_react2['default'].createElement(
					'div',
					{ to: href, className: styles.AdLink, onClick: onClick },
					children
				)
			);
		}

		return _react2['default'].createElement(
			'div',
			{ className: adClassNames },
			_react2['default'].createElement(
				'a',
				{ href: href, className: styles.AdLink, target: '_blank' },
				children
			)
		);
	};

	_createClass(Ad, null, [{
		key: 'propTypes',
		value: {
			children: _react.PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.object]),
			className: _react.PropTypes.string,
			href: _react.PropTypes.string,
			onClick: _react.PropTypes.func,
			ratio: _react.PropTypes.string
		},
		enumerable: true
	}, {
		key: 'defaultProps',
		value: {
			ratio: '4x3'
		},
		enumerable: true
	}]);

	return Ad;
})(_react.Component);

exports['default'] = Ad;
module.exports = exports['default'];
}.call(window));


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Ad/Ad.js
 ** module id = 671
 ** module chunks = 0
 **/